<template>
  <div id="app" class="font-sans overflow-x-hidden">
    <About />
    <Game />
    <News />
    <Job />
  </div>
</template>

<script>
import Game from '@/components/Game.vue'
import About from '@/components/About.vue'
import News from '@/components/News.vue'
import Job from '@/components/Job.vue'

export default {
  name: 'App',
  components: {
    Job,
    News,
    About,
    Game
  },
  mounted() {
    // 初始化滚动效果
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll() // 初始检查

    // 初始化滚动显示动画
    this.revealElements()
    window.addEventListener('scroll', this.revealElements)

    // 视差滚动效果监听
    window.addEventListener('scroll', this.handleParallaxScroll)

    // 导航项激活状态监听
    window.addEventListener('scroll', this.handleNavActiveState)

    // 初始化产品分类按钮交互
    this.initCategoryButtons()

    // 初始加载时检查淡入元素
    window.addEventListener('load', () => {
      setTimeout(this.checkFadeElements, 300)
    })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('scroll', this.revealElements)
    window.removeEventListener('scroll', this.handleParallaxScroll)
    window.removeEventListener('scroll', this.handleNavActiveState)
  },
  methods: {
    handleScroll() {
      // 导航栏滚动效果 - 保持高度不变（移除内边距切换）
      const navbar = document.getElementById('navbar')
      if (navbar) {
        // 确保导航栏宽度和高度不变
        navbar.style.width = '100%'

        if (window.scrollY > 50) {
          // 只修改背景和阴影，不改变内边距（避免高度变化）
          navbar.classList.add('bg-dark/80', 'nav-blur', 'shadow-lg')
          // 移除内边距切换逻辑，保持高度一致
        } else {
          navbar.classList.remove('bg-dark/80', 'nav-blur', 'shadow-lg')
          // 移除内边距切换逻辑，保持高度一致
        }
      }
    },

    // 视差滚动效果
    handleParallaxScroll() {
      const scrollY = window.scrollY
      document.documentElement.style.setProperty('--scroll-y', scrollY * 0.4 + 'px')
    },

    // 滚动显示动画
    // 滚动显示动画（增加重置逻辑）
    revealElements() {
      const reveals = document.querySelectorAll('.reveal, .fade-in')
      const windowHeight = window.innerHeight

      for (const element of reveals) {
        const elementTop = element.getBoundingClientRect().top

        // 元素进入视口：添加动画类
        if (elementTop < windowHeight) {
          element.classList.add('active', 'visible')
        } else {
          // 元素顶部超过视口顶部时就重置
          element.classList.remove('active', 'visible')
        }
      }
    },

    // 检查淡入元素
    checkFadeElements() {
      this.revealElements()
    },

    // 导航项激活状态处理
    handleNavActiveState() {
      let current = ''
      const sections = document.querySelectorAll('section')

      sections.forEach(section => {
        const sectionTop = section.offsetTop

        if (window.scrollY >= (sectionTop - 150)) {
          current = section.getAttribute('id') || ''
        }
      })

      // 更新URL哈希值
      if (current && window.location.hash !== `#${current}`) {
        // 使用replaceState避免添加到浏览器历史记录
        window.history.replaceState(null, null, `#${current}`)
      } else if (!current && window.location.hash) {
        // 当没有匹配的section时移除哈希
        window.history.replaceState(null, null, window.location.pathname)
      }

      const navItems = document.querySelectorAll('.nav-item')
      navItems.forEach(item => {
        item.classList.remove('active')
        if (item.getAttribute('href')?.substring(7) === current) {
          item.classList.add('active')
        }
      })
    },

    // 产品分类按钮交互
    initCategoryButtons() {
      const categoryButtons = document.querySelectorAll('#games .rounded-full')
      categoryButtons.forEach(button => {
        button.addEventListener('click', function() {
          categoryButtons.forEach(btn => {
            btn.classList.remove('bg-primary')
            btn.classList.add('bg-dark-light', 'hover:bg-dark-light/70')
          })

          this.classList.remove('bg-dark-light', 'hover:bg-dark-light/70')
          this.classList.add('bg-primary')
        })
      })
    }
  }
}
</script>
